"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
function dispatchEvent(message) {
    const event = new CustomEvent('LiqaHintMessage', { detail: message });
    window.dispatchEvent(event);
}
let prevHintMessage = '';
class LiqaWebCam {
    constructor(videoElement, canvasElement, invisibleCanvas, liqaConfig, Liqa) {
        this.width = 400;
        this.height = 500;
        this._videoElement = videoElement;
        this._canvasElement = canvasElement;
        this._invisibleCanvas = invisibleCanvas;
        this._isInitialized = false;
        this._liqa = null;
        this.Liqa = Liqa;
        this._config = liqaConfig;
        this._hintSubscription = rxjs_1.Subscription;
        this._playSubscription = rxjs_1.Subscription;
        this.onDestroy = new rxjs_1.Subject();
    }
    initialize(width, height) {
        return __awaiter(this, void 0, void 0, function* () {
            const t1 = performance.now();
            this._videoElement.height = this.height;
            this._videoElement.width = this.width;
            this._liqa = yield this.Liqa.init({
                video: this._videoElement,
                canvas: this._canvasElement,
                size: [width, height],
                strictness: this._config['strictness'],
            });
            const t2 = performance.now();
            console.log(`[liqa.Lite.init()] ${(t2 - t1) / 1000} seconds.`);
            this._hintSubscription = this._liqa.qualityStatus$.pipe((0, operators_1.takeUntil)(this.onDestroy)).subscribe(options => {
                this.hintMessages(options);
            });
        });
    }
    snap() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._canvasElement) {
                const t1 = performance.now();
                this.stop();
                let base64Image;
                base64Image = yield this._liqa.captureSelfie();
                const t2 = performance.now();
                console.log(`[liqa.Lite.captureSelfie()] ${(t2 - t1) / 1000} seconds.`);
                return base64Image;
            }
            else {
                throw new Error('Canvas element is missing');
            }
        });
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!this._isInitialized) {
                    yield this.initialize(this.width, this.height);
                }
                return yield this._liqa.play();
            }
            catch (error) {
                console.log('[liqaLite.start.error] ', error);
                throw error;
            }
        });
    }
    stop() {
        if (this._liqa) {
            console.log('[camera-status-before-stopping]', this._liqa['camera']['status']);
            this._liqa.stop();
            this._hintSubscription.unsubscribe();
        }
    }
    unMountLiqa() {
        this._liqa.unmount();
    }
    exitLiqa() {
        this._liqa.exit();
    }
    hintMessages(options) {
        if (options.status !== prevHintMessage) {
            prevHintMessage = options.status;
            dispatchEvent(options.status);
        }
    }
    checkCameraAvailability() {
        return null;
    }
}
exports.default = LiqaWebCam;
